import client from '@/lib/axios-client'
import type { OrganizationOutput } from '@/types/organization'

const ORG_URL = '/organization'

// ── GET /organization ─────────────────────────────────────────────────────────

export async function getOrganization(
	showHidden = false,
): Promise<OrganizationOutput> {
	const response = await client.get(ORG_URL, {
		params: showHidden ? { showHidden: true } : undefined,
	})
	return response.data.data.items
}
